export default "__VITE_ASSET__2u7YN_5t__"